//
import { client } from '../../graphql/client';
import { DeleteClients } from '../../graphql/generated-queries/delete-clients-queries';

export async function removeClient(input) {
  try {
    return await client.mutate({ mutation: DeleteClients, variables: { ids: [input.id] } });
  } catch (err) {
    console.error(err);
  }
}
